import React, { useCallback, useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";
import { EarningsBoard } from "@/components/bp/EarningsBoard";

export default function BpGains() {
  const { me } = useOutletContext();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const load = useCallback(async () => {
    setLoading(true);
    try { const { data: d } = await api.get("/bp/earnings"); setData(d); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-6 lg:p-10 space-y-6" data-testid="bp-gains">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#868E96] font-bold mb-2">// Mes gains</div>
          <h1 className="font-display text-4xl font-black tracking-tighter">Commissions & versements</h1>
          <p className="text-sm text-[#495057] mt-2">Commission fixe par formule, due une fois au premier paiement du client, validée par PAG puis versée le {data?.next_payout?.date ? new Date(data.next_payout.date).getDate() : 10} du mois (minimum {data?.next_payout?.min ?? 50} €).{me?.code ? "" : ""}</p>
        </div>
        <Button variant="outline" onClick={load} disabled={loading} className="h-10" data-testid="bp-gains-refresh"><RefreshCw className={`h-4 w-4 mr-2 ${loading ? "animate-spin" : ""}`} />Actualiser</Button>
      </div>
      <EarningsBoard data={data} />
    </div>
  );
}
